import request from '../request';

export const rewardApi = {
  getTradingBonus() {
    return request.get('/gw/a/reward/tradingBonus');
  },
  getRewardCourse() {
    return request.get('/gw/a/reward/courses');
  },
  getRewardCategory() {
    return request.get('/gw/a/reward/categories');
  },
  getRewardFee(data) {
    let _data = {
      ...data,
    };
    return request({
      url: '/gw/a/reward/fee',
      method: 'get',
      params: _data,
    });
  },
  exportRewardFee(data) {
    delete data.size;
    delete data.current;

    let _data = {
      ...data,
    };
    return request.get('/gw/a/reward/fee/export', {
      params: _data,
      responseType: 'arraybuffer'
    });
  }
};
